import React from 'react';
import { withRouter } from 'src/helpers';
import { MainSection, Container, features } from './Base';
import BaseComponent from 'src/components/BaseComponent';

class HomeDoctor extends BaseComponent {
  render() {
    return (
      <Container
        features={features}
        mainSection={<MainSection joinTo={'/signup-clinic'} joinText={'As a clinic'} />}
      />
    );
  }
}

export default withRouter(HomeDoctor);
